import { useEffect, useState } from "react";
import { Star, Share2, UserPlus } from "lucide-react";
import { api } from "@/lib/api";
import { useProfile } from "@/context/ProfileContext";
import ProductCard from "@/components/ProductCard";

const shareOnWhatsApp = (name) => {
  const url = `${window.location.origin}/#piu-amati`;
  const who = name ? `${name} ti consiglia` : "Ti consiglio";
  const text = `${who} i capi più amati di Minime Baby: abbigliamento neonato 100% cotone, delicato e bellissimo 🤍\n${url}`;
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener");
};

export default function MostLoved({ onJoin }) {
  const { profile, addToWishlist, inWishlist } = useProfile();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/catalog/most-loved", { params: { profile_id: profile?.id, limit: 10 } })
      .then(({ data }) => setData(data)).catch(() => setData(false));
  }, [profile?.id]);

  useEffect(() => {
    if (data?.products?.length && window.location.hash === "#piu-amati") {
      document.getElementById("piu-amati")?.scrollIntoView({ behavior: "smooth" });
    }
  }, [data]);

  if (data === null) return <div className="min-h-[420px] sm:min-h-[520px]" data-testid="most-loved-loading" />;
  if (!data?.products?.length) return null;

  return (
    <section id="piu-amati" data-testid="most-loved" className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-8 sm:py-12 scroll-mt-16">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6">
        <div>
          <div className="flex items-center gap-2 text-[#C87D75] mb-2">
            <Star size={16} className="fill-[#E5A8A0] stroke-[#C87D75]" />
            <span className="text-xs uppercase tracking-[0.2em] font-semibold">Vetrina</span>
          </div>
          <h2 className="font-serif text-2xl sm:text-3xl text-[#2D2825]" data-testid="most-loved-title">I più amati</h2>
          <p className="text-sm text-[#5C534E] mt-1 max-w-xl">
            {data.personalized
              ? "I capi più belli del negozio scelti dalla nostra AI, disponibili e adatti a stagione, taglia e sesso del tuo bimbo."
              : "I capi più belli del negozio, scelti dalla nostra AI."}
          </p>
        </div>
        <div className="flex flex-wrap gap-2 self-start sm:self-auto">
          {!profile && onJoin && (
            <button data-testid="most-loved-join" onClick={onJoin}
              className="inline-flex items-center gap-2 rounded-full border border-[#C87D75] text-[#C87D75] hover:bg-[#F9ECE9] px-5 min-h-[44px] text-sm transition-colors">
              <UserPlus size={15} /> Crea il tuo profilo
            </button>
          )}
          <button data-testid="most-loved-share-whatsapp" onClick={() => shareOnWhatsApp(profile?.name)}
            className="inline-flex items-center gap-2 rounded-full bg-[#4E7363] hover:bg-[#3d5a4e] text-white px-5 min-h-[44px] text-sm transition-colors">
            <Share2 size={15} /> Condividi su WhatsApp
          </button>
        </div>
      </div>
      <div className="loved-rail" data-testid="most-loved-rail">
        {data.products.map((p, i) => (
          <ProductCard key={p.id} product={p} onAdd={addToWishlist} inList={inWishlist(p.id)}
            delay={Math.min(i, 5) * 0.04} testid={`most-loved-card-${p.id}`} />
        ))}
      </div>
    </section>
  );
}
